import React from "react";
import "../DashboardUnique.css";

export default function VillageWiseMandalDetailHeader({ village, handleNavigateToMainTab, selectedBhajanMandaliType, totalMandaliInVillage, selectedVillage, theme }) {
  console.log("checkingthevalueOfTheme", theme);
  return (
    <div className={`govdash-villageDetailHeader`}>
      <div onClick={handleNavigateToMainTab} className={"govdash-detailIconWrapper cursor-pointer"}>
        <i className="govdash-VillageHeaderCard-icon  fas fa-house-user"></i>
      </div>
      <div className={"govdash-detailInfo"}>
        <div className="d-flex align-items-center gap-2">
          <h2 className="govdash-detailName mb-0">{selectedBhajanMandaliType?.bhajanMandaliType}</h2>

          {/* <span className="village-chip">{selectedVillage?.VillageName}</span> */}
        </div>
        <div className={"govdash-detailStats"}>
          <div className={"govdash-statItem "}>
            {/* <span className={"govdash-statLabel"}>Mandali Count</span> */}
            <span className={"govdash-statLabel"}>Member Count</span>
            <span className={"govdash-statValue"}>{selectedVillage?.TotalBhajanMandaliMember}</span>
          </div>
          {/* <div className={"govdash-statItem "}>
            <span className={"govdash-statLabel"}>Village Name</span>
            <span className={"govdash-statValue"}>{selectedVillage?.VillageName}</span>
          </div> */}
          <div className={"govdash-statItem "}>
            <span className={"govdash-statLabel"}>Mandali Count</span>
            <span className={"govdash-statValue"}>{totalMandaliInVillage}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
